import File from './models/File';
import Events from './Events';

class State {
	constructor() {
		this.files = [];
		this.uploadingFiles = [];
		this.compressionModes = {
			Normal: { name: 'Normal', quality: 85, speed: 3, ectLevel: 5 },
			Good: { name: 'Good', quality: 80, speed: 1, ectLevel: 5 },
			High: { name: 'High', quality: 70, speed: 1, ectLevel: 9 },
			Extreme: { name: 'Extreme', quality: 60, speed: 1, ectLevel: 9 }
		};
		this.compressionMode = this.compressionModes.Good;
		this.landingPageHidden = false;
	}

	get downloadFileUrls() {
		return this.files.filter(file => { // filter already optmized files
			return file.percentageCompression > 0;
		}).map(file => {
			return file.url;
		});
	}
	addFile(id, name, size) {
		if (id) {
			if (this.landingPageHidden === false && this.files.length === 0) {
				this.landingPageHidden = true;
				Events.ShowFileTable();
			}
			const file = new File(id, name, size, this.compressionMode);
			this.files.unshift(file);
			Events.RaiseFileAdded();
			Events.RaiseUploading();
		}
	}
	removeFile(uid) {
		const index = this.files.findIndex(file => { return file.key === uid; });
		this.files.splice(index, 1);
		Events.RaiseFileRemoved();
	}
	clearFiles() {
		this.files = [];
		Events.RaiseFilesDeleted();
	}
	isUploading = () => {
		if (this.files && this.files.length > 0) {
			return this.files.some(file => {
				return file.url === undefined;
			});
		}
		return false;
	}
	done(uid, response) {
		const index = this.files.findIndex(file => { return file.key === uid; });
		this.files[index].updateFromResponse(response);
		if (!this.isUploading()) Events.RaiseUploadingDone();
	}
	updateProgress(uid, percent) {
		const uploadingFile = this.files.find(file => { return file.key === uid; });
		if (uploadingFile) uploadingFile.updateProgress(percent);
	}
}

const state = new State();
export default state;



// WEBPACK FOOTER //
// ./src/State.js